@if (data) {
  <div
    [class]="{
      'hero-block': true,
      'hero-block--content-right': contentRight,
      'hero-block--image-cropped': croppedImage,
      'hero-block--secondary': isSecondaryImage,
      'hero-block--overlay-block': isGridOverlapBlock
    }"
  >
    <dotcom-frontend-image
      [addToPreload]="true"
      [class]="{
        'hero-block__image-container': true,
        'hero-block__image-container--cropped': croppedImage
      }"
      [image]="image"
      fetchPriority="high"
      loading="eager"
    />
    <div lgContainer>
      <div [class]="{ 'animate-container': hasAnimation, animate: animate }">
        <div class="inner">
          <div
          [class]="['hero-block__content', contentBgColor]"
          [lgColLg]="6"
          [lgCol]="12"
        >
        <div [class]="{ 'animate-container-mobile': hasAnimation, animate: animate }">
          <h1
            [innerHTML]="heroTitle | safeHtml"
            [wysiwygContainer]="'Hero Component'"
            class="hero-block__title lg-font--expressive lg-font-size-7 lg-font-size-7--medium"
            dotcomFrontendWysiwyg
          ></h1>

          @if (heroSubTitle) {
            <div
              [innerHTML]="heroSubTitle | safeHtml"
              [wysiwygContainer]="'Hero Component'"
              class="hero-block__subtitle wysiwyg"
              dotcomFrontendWysiwyg
            ></div>
          }

          @if (showFindOutMoreLink) {
            <a
              (click)="scrollToMainContent()"
              class="hero-block__find-out-more"
            >
              {{ mainContentAnchorText }}
            </a>
          }

          @if (ctaButtons) {
            <div
              [class]="{
                animate: animate,
                'hero-ctas-container': hasAnimation
              }"
            >
              @if (!isLinkList) {
                @for (button of ctaButtons; let i = $index; track i) {
                  <dotcom-frontend-loader
                    [componentData]="button"
                    cssClass="hero-block__button"
                  />
                }
              } @else {
                <dotcom-frontend-loader [componentData]="ctaButtons" />
              }
            </div>
          }
        </div>
        </div>
        </div>
      </div>
    </div>

    @if (data && heroOverlapBlocks && isHeroTabLinks) {
      <ng-container [ngTemplateOutlet]="heroOverlapContent"></ng-container>
    }
  </div>
}

@if (data && heroOverlapBlocks && isGridOverlapBlock) {
  <ng-container [ngTemplateOutlet]="heroOverlapContent"></ng-container>
}

<ng-template #heroOverlapContent>
  <div
    [class]="{
      'hero-tab-links': isHeroTabLinks,
      'hero-overlap-block': isGridOverlapBlock
    }"
  >
    @for (block of heroOverlapBlocks; let i = $index; track i) {
      <dotcom-frontend-loader [componentData]="block" />
    }
  </div>
</ng-template>
